import { render, staticRenderFns } from "./giftListPage.vue?vue&type=template&id=6d9a0d4c&"
import script from "./giftListPage.vue?vue&type=script&lang=js&"
export * from "./giftListPage.vue?vue&type=script&lang=js&"
import style0 from "./giftListPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d9a0d4c')) {
      api.createRecord('6d9a0d4c', component.options)
    } else {
      api.reload('6d9a0d4c', component.options)
    }
    module.hot.accept("./giftListPage.vue?vue&type=template&id=6d9a0d4c&", function () {
      api.rerender('6d9a0d4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/giftListPage.vue"
export default component.exports